module.exports = __webpack_public_path__ + "static/media/publicize_video.458d1b3a.mp4";